import ThreeImageBlock from "./ThreeImageBlock"

export default ThreeImageBlock
